import { sydDate } from "../../lib/time";

const fmtDate = (iso) => sydDate(iso, "None");

function Block({ label, children, testid }) {
  return (
    <div className="mt-4" data-testid={testid}>
      <div className="label-eyebrow">{label}</div>
      <div className="mt-1 text-brand-ink whitespace-pre-wrap">{children}</div>
    </div>
  );
}

// Category-specific factual content of an action card (all from Stage 1 data).
export function CardDetails({ card }) {
  const k = card.category.key;
  const id = card.id;
  const m = card.missed;
  return (
    <>
      {(k === "red_blue" || k === "red" || k === "blue") && (
        <Block label={k === "blue" ? "Weekly synopsis / context" : "Weekly synopsis"} testid={`card-synopsis-${id}`}>{card.weekly_synopsis || "None"}</Block>
      )}
      {(k === "red_blue" || k === "red") && (
        <>
          <Block label="Why she was escalated" testid={`card-escalation-${id}`}>{card.red_escalation_reason || "None"}</Block>
          <div className="mt-4" data-testid={`card-quotes-${id}`}>
            <div className="label-eyebrow">In her words</div>
            <ul className="mt-1 space-y-1">
              {(card.red_problem_quotes || []).map((q, i) => (
                <li key={i} className="italic text-brand-ink border-l-2 border-[#C0392B] pl-3" data-testid={`card-quote-${id}-${i}`}>“{q}”</li>
              ))}
            </ul>
          </div>
        </>
      )}
      {(k === "red_blue" || k === "blue") && (
        <Block label="Her message to Justine" testid={`card-support-${id}`}>{card.support_request || "None"}</Block>
      )}
      {k === "orange" && m && (
        <div className="mt-4 grid grid-cols-1 md:grid-cols-3 gap-4" data-testid={`card-missed-${id}`}>
          <Block label="Week since starting" testid={`card-week-number-${id}`}>Week {m.week_number}</Block>
          <Block label="Total missed since starting" testid={`card-total-missed-${id}`}>{m.total_missed}</Block>
          {m.consecutive_streak ? <Block label="Consecutive missed" testid={`card-streak-${id}`}>{m.consecutive_streak} in a row</Block> : null}
          <div className="md:col-span-3" data-testid={`card-missed-windows-${id}`}>
            <div className="label-eyebrow">Missed Weekly Check-Ins</div>
            <p className="mt-1 text-brand-ink">{m.missed_windows.map((w) => w.label).join(" · ")}</p>
          </div>
        </div>
      )}
      {k === "yellow" && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Block label="Client start date" testid={`card-start-date-${id}`}>{fmtDate(card.client_created_at)}</Block>
          {card.setup && (
            <Block label="Weekly Check-In Setup" testid={`card-setup-status-${id}`}>
              {card.setup.setup_completed ? `Completed ${fmtDate(card.setup.setup_completed_at)} · first Weekly Check-In not yet submitted` : "Not completed yet"}
            </Block>
          )}
        </div>
      )}
    </>
  );
}

export default CardDetails;
